export function updateArticlesState(state, payload) {
  state[payload.state] = payload.data;
}
